import React, {FC} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'

import './style/index.less'
import {Icon} from "@/components";
import log from "@/utils/log";

interface ColseDownTypes {
  msg: string;
  changeCloseShow?: (bool: boolean) => void
}
type ColseDownPorps = StylesType & ColseDownTypes

const CloseDown: FC<ColseDownPorps> = props => {
  const {prefixCls = 'gc_close_down_', msg, changeCloseShow, className=''} = props
  const close = () => {
    changeCloseShow && changeCloseShow(false)
    log({eventId: 'E2202', pageId: 'P22', ext: ''})
  }
  return (
    <>
      <div className={classnames(prefixCls,className)}>
        <div className={classnames(prefixCls+'body')}>
          <div className={classnames(prefixCls+'close')} onClick={() => close()}>
            <Icon type='iconxinjianicon' className={classnames(prefixCls+'icon')}/>
          </div>
          <div
            className={classnames(prefixCls + 'content')}
            dangerouslySetInnerHTML = {{ __html: msg }}
          >
          </div>
        </div>
      </div>
    </>
  )
}

export default CloseDown
